<template>
    <div class="about__section">
        <h3>{{ l('ABOUT.SERVICE_WORKERS') }}</h3>
        <dl>
            <dt>{{ l('ABOUT.SERVICE_WORKERS_STATUS') }}</dt>
            <dd>
                <template v-if="serviceWorkerRegistered">
                    {{ l('ABOUT.SERVICE_WORKERS_REGISTERED') }}
                </template>
                <template v-else>
                    {{ l('ABOUT.SERVICE_WORKERS_NOT_REGISTERED') }}
                </template>
            </dd>

            <template v-if="serviceWorkerRegistered">
                <dt></dt>
                <dd>
                    <button class="btn btn-default btn-sm"
                            @click="removeServiceWorkers()">
                        {{ l('ABOUT.SERVICE_WORKERS_REMOVE') }}
                    </button>
                </dd>
            </template>
        </dl>
    </div>
</template>

<script>
export default {
    name: 'AboutServiceWorkersSection',

    data() {
        return {
            serviceWorkerRegistered: false,
        };
    },

    created() {
        navigator.serviceWorker.getRegistrations()
            .then((registrations) => {
                if (registrations.length > 0) {
                    this.serviceWorkerRegistered = true;
                }
            })
            .catch((e) => {
                console.error(e);
            });
    },

    methods: {
        removeServiceWorkers() {
            window.location.href = 'https://' + window.location.host + '/epos/service-worker-remove.html';
        },
    },
};
</script>
